'use strict';

const _=require('pulsar-utils/dist-es6/_');
const path=require('path');
const angular=require('angular');
const angularUiRouter=require('angular-ui-router');
const CompatibilityHelpers=require('../../../dist-es6/client/utilities/compatibilityHelpers');

const StripComments=/((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
const CaptureArgumentNames=/([^\s,]+)/g;

function _getParamNames(func){
const funcString=func.toString().replace(StripComments,'').replace(/\s/g,'');
const ctorIndex=funcString.indexOf('constructor(');
const startingPoint=ctorIndex===-1?0:ctorIndex;
const startOfParams=startingPoint+funcString.slice(startingPoint).indexOf('(')+1;
const endOfParams=startOfParams+funcString.slice(startOfParams).indexOf(')');
return funcString.slice(startOfParams,endOfParams).match(CaptureArgumentNames)||[];
}

function _getAngularFactory(factory){
const asString=factory.toString();
const isClass=/_classCallCheck/.test(asString);

if(!isClass){
return factory;
}

function newFactory(...args){
if(this){

return factory.apply(this,args);
}else{
return new factory(...args);
}
}

newFactory.prototype=factory.prototype;
newFactory.$inject=_getParamNames(asString);

if(factory.$inject&&factory.$inject.join(',')!==newFactory.$inject.join(',')){
console.warn(`mismatched $inject for ${factory.name} - ctor: (${newFactory.$inject.join(',')}), $inject: [${factory.$inject.join(',')}]`);
}

return newFactory;
}

function getComponentType(component){
switch(component.type){
case'controller':
return'controller';
case'directive':
case'controllerBackedDirective':
return'directive';
case'service':
return'service';
case void 0:
case null:
return CompatibilityHelpers.getComponentTypeFromClassName(component);
default:
throw new Error(`Unable to determine type of angular component ${component.prototype.constructor.name}, type=${component.type}.`);}

}

function getRegistrationNameFor(component,type){
let componentName=component.prototype.constructor.name;

if(type==='service'){
componentName=_.camelCase(componentName);
}else if(type==='directive'){
componentName=`pulsar${componentName.replace(/Directive$/g,'')}`;
}

return componentName;
}let

AngularHelpers=class AngularHelpers{
static registerComponents(module,components){
for(const component of components){
const type=getComponentType(component);
const componentName=getRegistrationNameFor(component,type);

if(type==='directive'){
const directive=new component;
const newFactory=directive.factory.bind(directive);
newFactory.$inject=directive.factory.$inject;
module.directive(componentName,newFactory);
}else{
module[type](componentName,component);
}
}
}

static registerModule(moduleInfo){
const dependencies=_.exists(moduleInfo.dependencies)?moduleInfo.dependencies:[];
const module=angular.module(moduleInfo.name,dependencies);
if(_.exists(moduleInfo.configs)){
for(const config of moduleInfo.configs){
module.config(_getAngularFactory(config));
if(_.exists(config.runFunction)){
module.run(config.runFunction);
}
}
}
if(_.exists(moduleInfo.components)){
AngularHelpers.registerComponents(module,moduleInfo.components);
}

return moduleInfo.name;
}

static generateFeatureConfig(featureShortName,configOverrides={},parentFolder='./'){
const featureDirectory=path.join('/templates/features/',parentFolder,featureShortName);
const featureFullName=`fdc.features.${featureShortName}`;
const featureUrl=path.join('/',featureShortName);
const mainView={
templateUrl:path.join(featureDirectory,`${featureShortName}View`),
controller:`${_.upperFirst(featureShortName)}Controller as controller`};


const baseConfig={
url:featureUrl,
views:{
"main@":mainView},

params:{}};


return{
fullName:featureFullName,
config:_.defaultsDeep(configOverrides,baseConfig)};

}

static generateAuthenticatedFeatureConfig(featureName,configOverrides={},parentFolder='./'){
const baseAuthenticatedConfig={
params:{
authenticated:!1}};


return AngularHelpers.generateFeatureConfig(featureName,_.defaultsDeep(configOverrides,baseAuthenticatedConfig),parentFolder);
}

static getDigestSpeed({logResult=!0}={}){
let numMs;
angular.element(document).injector().invoke($rootScope=>{
const start=performance.now();
$rootScope.$apply();
numMs=performance.now()-start;
if(logResult){
console.info(`Digest Time: ${numMs}`);
}
});
return numMs;
}

static getWatchers(root){


const scopeIds=new Set;
root=angular.element(root||document.documentElement);


function getElemWatchers(element){
const isolateWatchers=getWatchersFromScope(element.data().$isolateScope);
const scopeWatchers=getWatchersFromScope(element.data().$scope);
let watchers=scopeWatchers.concat(isolateWatchers);
angular.forEach(element.children(),function(childElement){
watchers=watchers.concat(
getElemWatchers(angular.element(childElement)));

});
return watchers;
}

function getWatchersFromScope(scope){
if(scope){
if(!scopeIds.has(scope.$id)){
scopeIds.add(scope.$id);
return scope.$$watchers||[];
}else{
return[];
}
}else{
return[];
}
}

function getWatcherExpressions(element){
const watchers=getElemWatchers(element);
const watchlist={
_total:watchers.length};


angular.forEach(watchers,function(watcher){
watchlist[watcher.exp]=watchlist[watcher.exp]||[];
watchlist[watcher.exp].push(watcher);
});

return watchlist;
}

return getWatcherExpressions(root);

}};


module.exports=AngularHelpers;
//# sourceMappingURL=angularHelpers.js.map
